import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, AlertCircle, Brain, Frown } from 'lucide-react';
export function ChainReaction() {
  const steps = [{
    icon: Clock,
    label: 'Wake Up'
  }, {
    icon: AlertCircle,
    label: 'Discomfort'
  }, {
    icon: Brain,
    label: 'Thoughts'
  }, {
    icon: Frown,
    label: 'Panic'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1e2a38] mb-4" data-id="element-22">
            The Chain Reaction
          </h2>
          <p className="text-lg text-gray-600" data-id="element-23">The loop you know too well.</p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-12" data-id="element-24">
          {steps.map((step, index) => <Fragment key={index} data-id="element-25">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="flex flex-col items-center gap-3 p-6 bg-[#f5f0e8] rounded-xl w-full md:w-48 shadow-sm border border-[#1e2a38]/5" data-id="element-26">
                <div className="w-12 h-12 rounded-full bg-[#1e2a38] flex items-center justify-center text-[#c9a07a]" data-id="element-27">
                  <step.icon size={24} data-id="element-28" />
                </div>
                <span className="font-medium text-[#1e2a38]" data-id="element-29">{step.label}</span>
              </motion.div>

              {index < steps.length - 1 && <div className="hidden md:block text-[#c9a07a]" data-id="element-30">
                  <ArrowRight size={24} data-id="element-31" />
                </div>}
              {index < steps.length - 1 && <div className="md:hidden text-[#c9a07a] rotate-90 my-2" data-id="element-32">
                  <ArrowRight size={24} data-id="element-33" />
                </div>}
            </Fragment>)}
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-34">
          <p className="text-xl font-medium text-[#1e2a38]" data-id="element-35">
            Wake up → discomfort → thoughts → time checking → panic → more
            thoughts → more alertness →{' '}
            <span className="text-[#c9a07a] font-bold" data-id="element-36">
              now it's basically morning.
            </span>
          </p>
          <p className="mt-6 text-gray-600 italic" data-id="element-37">
            This isn't a character flaw. It's a predictable loop. And
            predictable loops can be interrupted.
          </p>
        </div>
      </div>
    </section>;
}